/**
 * The range presets (C2; TMMAPP-0108; v2 `_dlRange`) — one vocabulary for the downloads and the
 * virtual account P&L view (TMMAPP-0113 4e): Year to date, Last 12 months, This month, Last month,
 * Last year ("This quarter" retired so the two read the same).
 */
export const RANGE_PRESETS = ['ytd', '12m', 'month', 'lastMonth', 'lastYear'] as const;

export type RangePreset = (typeof RANGE_PRESETS)[number];

const pad = (n: number) => String(n).padStart(2, '0');

const civil = (year: number, month: number, day: number) => `${year}-${pad(month)}-${pad(day)}`;

const lastDay = (year: number, month: number) => new Date(year, month, 0).getDate();

/** A preset's `[from, to]` from the civil `today` (v2 `_dlRange`). */
export function presetRange(preset: RangePreset, today: string): [string, string] {
  const [y = 0, m = 1] = today.split('-').map(Number);
  switch (preset) {
    case 'month':
      return [civil(y, m, 1), today];
    case 'lastMonth': {
      const year = m === 1 ? y - 1 : y;
      const month = m === 1 ? 12 : m - 1;
      return [civil(year, month, 1), civil(year, month, lastDay(year, month))];
    }
    case 'ytd':
      return [civil(y, 1, 1), today];
    case 'lastYear':
      return [civil(y - 1, 1, 1), civil(y - 1, 12, 31)];
    case '12m':
      return [m === 12 ? civil(y, 1, 1) : civil(y - 1, m + 1, 1), today];
  }
}
